import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const SittingApi = createApi({
  reducerPath: "SittingApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getTotalCount: builder.query({
      query: () => "get_total_counts",
      transformResponse: (response) => response.data,
    }),
    getAllocationCount: builder.query({
      query: () => "get_allocation_counts",
      transformResponse: (response) => response.data,
    }),
    getAllArrangmentData: builder.query({
      query: () => "get_all_arrangement",
      transformResponse: (response) => response,
    }),

    getUserSittingData: builder.query({
      query: (userList) => `get_user_sitting_data?user_id=${userList}`,
      transformResponse: (response) => response,
    }),
    getAllDataOfSitting: builder.query({
      query: () => `get_all_data_of_sitting`,
      transformResponse: (response) => response,
    }),

    editSittingArrangment: builder.mutation({
      query: (editsub) => ({
        url: `update_sitting_arrangement`,
        method: "PUT",
        body: editsub,
      }),
    }),
  }),
});

export const {
  useGetTotalCountQuery,
  useGetAllocationCountQuery,
  useGetAllArrangmentDataQuery,
  useGetUserSittingDataQuery,
  useGetAllDataOfSittingQuery,
  useEditSittingArrangmentMutation,
} = SittingApi;

export default SittingApi;
